import { storage } from '~/shared/storage'

/**
 * The shell's namespace. Last-viewed customer is the shell's state rather than an app's: `Bootstrap`
 * reads it and `CustomerLayout` writes it.
 */
const shellStorage = storage.for('shell')

const LAST_CUSTOMER_KEY = 'lastCustomer'

/**
 * Reads the last-viewed customer, or null when none is stored or storage is unavailable.
 *
 * A convenience for picking a sensible default at bootstrap, never an authorization input: the
 * caller validates it against the accessible customer list before using it.
 */
export const getLastCustomer = (): string | null =>
  shellStorage.get(LAST_CUSTOMER_KEY)

/**
 * Persists the last-viewed customer.
 *
 * Does nothing when storage is unavailable, in which case the next visit falls back to another
 * default.
 */
export const setLastCustomer = (customerRegardId: string): void => {
  shellStorage.set(LAST_CUSTOMER_KEY, customerRegardId)
}
